<template>
  <div class="modal edit-contact animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title"> {{ $t('contact_modal.edit_contact') }}</p>
      </header>

      <section class="modal-card-body form">
        <div class="float-label full remove-padding-left">
          <input type="text" name="name" id="name" v-validate="'required'" v-model.trim="contact.name" @keyup.enter="saveContact()" required>
          <label for="name">{{ $t('contact_modal.name_input.label') }}</label>
          <span class="help-block" v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
        <div class="float-label half remove-padding-left">
          <input type="email" name="email" id="email" v-validate="'required|email|duplicate_contact'" v-model.trim="contact.email" @keyup.enter="saveContact()" required>
          <label for="email">{{ $t('contact_modal.email_input.label') }}</label>
          <span class="help-block" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
        <div class="float-label half remove-padding-right">
          <input type="text" name="company" id="company" v-validate="'required'" v-model.trim="contact.company" @keyup.enter="saveContact()" required>
          <label for="company">{{ $t('contact_modal.company_input.label') }}</label>
          <span class="help-block" v-show="errors.has('company')">{{ errors.first('company') }}</span>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary is-large is-pulled-left"
           :disabled="!contact.name || !contact.email || !contact.company || errors.any()"
           @click="saveContact()"
           v-if="!contact.deleted_at">{{ $t('inputs.save') }}</a>
        <a class="button is-primary is-outlined is-large is-pulled-right"
          @click="archiveContact()"
          v-if="!contact.deleted_at">{{ $t('inputs.archive') }}</a>
        <a class="button is-primary is-outlined is-large is-pulled-right"
          @click="unarchiveContact()"
          v-if="contact.deleted_at">{{ $t('inputs.unarchive') }}</a>
      </footer>
    </div>
  </div>
</template>

<script>
import API from 'mixins/api';
import { Validator } from 'vee-validate';

export default {
  mixins: [API],
  props: ['options'],
  data() {
    return {
      Events: window.Events,
      contact: {
        name: '',
        deleted_at: '',
        email: '',
        company: ''
      },
      showConfirmArchive: false
    }
  },
  beforeMount() {
    this.api().fetchTeamContacts()
      .then(contacts => this.contacts = contacts);

    Validator.extend('duplicate_contact', {
      getMessage: (field, args) => {
        return this.$t('contact_modal.contact_error_duplicate');
      },
      validate: (value, args)  => {
        return this.options.contact.email === value || !_.some(this.contacts, (contact) => { return contact.email === value; });
      }
    });
  },
  mounted() {
    if (this.options && this.options.contact) {
      this.contact = _.clone(this.options.contact);
    }
  },
  methods: {
    closeModal() {
      this.Events.$emit('modalClose', 'editContactModal');

      // Give it a moment to compose itself before clearing errors
      setTimeout(() => {
        if (this.$validator.errorBag) {
          this.$validator.errorBag.clear();
        }
      }, 10);
    },
    saveContact() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          // validation failed.
          (new Notyf()).alert(this.$t('contact_modal.contact_error'));
        }

        this.api().updateContact(this.contact.id, this.contact)
          .then(result => {
            (new Notyf()).confirm(this.$t('contact_modal.contact_saved'));
            this.closeModal();
          }, () => {
            (new Notyf()).alert(this.$t('contact_modal.contact_error'));
          });
      });
    },
    archiveContact() {
      this.showConfirmArchive = true;

      this.closeModal();
      Events.$emit('alertModal', {
        body: this.$t('contact_modal.confirm_archive', { contact_name: this.contact.name }),
        actions: ['Yes', 'No'],
        done: (action) => {
          if (action === 'Yes') {
            this.api().archiveContact(this.contact.id)
              .then(function(result) {
                Events.$emit('contactsChange');
                (new Notyf()).confirm(this.$t('contact_modal.contact_archived'));
              }, function() {
                (new Notyf()).alert(this.$t('contact_modal.contact_archived_error'));
              });
          }
        }
      });
    },
    unarchiveContact() {
      this.api().unarchiveContact(this.contact.id)
        .then((result) => {
          (new Notyf()).confirm(this.$t('contact_modal.contact_unarchived'));
          Events.$emit('contactsChange');
          this.closeModal();
        }, () => {
          (new Notyf()).alert(this.$t('contact_modal.contact_unarchived_error'));
        });
    }
  },
  watch: {
    options() {
      if (this.options && this.options.contact) {
        this.contact = _.clone(this.options.contact);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin: 2em;
  overflow: visible;
}
.full { width: 100%; }
.fadeIn {
  animation-duration: 500ms;
}
.fadeInUp {
  animation-duration: 500ms;
}
.modal-background {
  background: hsla(0,0%,100%,.3);
}
.is-pulled-right {
  margin-right: 0 !important;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// edit-contact-modal.vue?3cd02f70